import { useEffect, useState } from "react";
import { PlusCircle, MessageSquare } from "lucide-react";
import api from "../../lib/api";
import { RequestForm } from "./RequestForm";
import { AdminOrgDetail } from "./AdminOrgDetail";
import { Card, Pill, btnOutline, fmtDate } from "./ui";

export function AdminInstitutions({ onCount }) {
  const [orgs, setOrgs] = useState([]);
  const [open, setOpen] = useState(null);
  const [creating, setCreating] = useState(false);
  const load = () => api.get("/admin/institutions").then(({ data }) => { setOrgs(data.organizations); onCount?.(data.organizations.filter((o) => o.status === "New request").length); }).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (open) return <AdminOrgDetail id={open} onBack={() => { setOpen(null); load(); }} />;
  return (
    <div className="space-y-5" data-testid="admin-institutions">
      <div className="flex justify-between items-center flex-wrap gap-3">
        <p className="text-sm text-slate-600">{orgs.length} organizations · {orgs.filter((o) => o.status === "New request").length} new requests</p>
        <button type="button" className={btnOutline} onClick={() => setCreating(!creating)} data-testid="admin-create-org-btn"><PlusCircle className="w-4 h-4" /> Create organization manually</button>
      </div>
      {creating && <RequestForm adminEmail="" onDone={(d) => { setCreating(false); setOpen(d.id); }} />}
      <Card className="p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider"><tr>{["Organization", "Status", "Licenses used", "Contract end", "Latest quote", ""].map((h) => <th key={h} className="text-left px-5 py-3">{h}</th>)}</tr></thead>
          <tbody>{orgs.map((o) => (
            <tr key={o.id} className="border-t border-slate-100 hover:bg-slate-50 cursor-pointer" onClick={() => setOpen(o.id)} data-testid={`admin-org-row-${o.id}`}>
              <td className="px-5 py-3"><p className="font-semibold">{o.name} <span className="text-xs text-slate-400">{o.country}</span></p><p className="text-xs text-slate-500">{o.admin_email}</p></td>
              <td className="px-5 py-3"><Pill s={o.status} /></td>
              <td className="px-5 py-3">{o.seats.licenses ? `${o.seats.active + o.seats.invited} / ${o.seats.licenses}` : `— / ${o.requested}`}</td>
              <td className="px-5 py-3">{fmtDate(o.end)}</td>
              <td className="px-5 py-3">{o.value || "—"}</td>
              <td className="px-5 py-3">{o.unread > 0 && <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#1C6FE3]"><MessageSquare className="w-3.5 h-3.5" /> {o.unread}</span>}</td>
            </tr>
          ))}</tbody>
        </table>
        {orgs.length === 0 && <p className="text-sm text-slate-500 p-5">No institutional requests yet.</p>}
      </Card>
    </div>
  );
}
